export default __webpack_public_path__ + "static/allLocations-3601105f4fdc818cf3432435585de52c.png";